import { render, staticRenderFns } from "./Kicc.vue?vue&type=template&id=756a2146&scoped=true&"
import script from "./Kicc.vue?vue&type=script&lang=js&"
export * from "./Kicc.vue?vue&type=script&lang=js&"
import style0 from "./Kicc.vue?vue&type=style&index=0&id=756a2146&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "756a2146",
  null
  
)

export default component.exports